import React, { useState, useEffect } from 'react';
import { Provider, useSelector } from 'react-redux';
import { compose } from 'redux';

import store from '../../store';
import { FIRST_PAGE } from '../../constants/pagination';
import {
  supportRequestsRestHooks,
  selectEndate,
  selectStartdate,
  selectAuth0Id,
} from '../../store/SupportRequests/SupportRequestsSlice';
import { OPEN } from '../../presenters/SupportRequestPresenter';

import SupportRequestsTable from './components/SupportRequestsTable';
import Filters from './components/Filters';

const SupportRequestsContainer = () => {
  const endDate = useSelector(selectEndate);
  const startDate = useSelector(selectStartdate);
  const auth0Id = useSelector(selectAuth0Id);
  const initialParams = {
    byState: OPEN,
    createdAfter: startDate,
    createdBefore: endDate,
    byUser: auth0Id,
  };
  const [searchParams, setSearchParams] = useState({
    q: initialParams,
    page: FIRST_PAGE,
  });

  const {
    loadSupportRequests,
    loadResetSupportRequests,
    supportRequests: { loadingStatus, items, meta },
  } = supportRequestsRestHooks.use();

  const handlePageChange = ({ selected }) => {
    const newParams = { ...searchParams, page: selected + 1 };
    setSearchParams(newParams);

    loadSupportRequests(newParams);
  };

  useEffect(() => {
    loadSupportRequests(searchParams);
    return () => {
      loadResetSupportRequests();
    };
  }, []);

  return (
    <div className="support-requests">
      <div className="form-header">
        <h2>Support</h2>
      </div>
      <Filters
        searchParams={searchParams}
        onSearchParamsChange={setSearchParams}
        onLoad={loadSupportRequests}
      />
      <SupportRequestsTable
        requests={items}
        meta={meta}
        onPageChange={handlePageChange}
        loadingStatus={loadingStatus}
      />
    </div>
  );
};

const addStore = (ProxyComponent) => (props) =>
  (
    <Provider store={store}>
      <ProxyComponent {...props} />
    </Provider>
  );

export default compose(addStore)(SupportRequestsContainer);
